import * as _ from "lodash";
import engagementResource from "app/common/resources/userEngagementResource";

const DID_COMPARE = "didCompare";
export const STATE_COMPARE_PREFIX = "compareMode";
export const SIDEBAR_3_WIDTH = 49;
export const SECONDARY_SIDEBAR_3_WIDTH = 241;
export const DEFAULT_SIDEBAR_WIDTH = 300;

declare const window;

const getWebsiteLink = (domain = "") => {
    if (_.startsWith(domain, "*")) {
        return null;
    } else {
        return `http://${domain}`;
    }
};

const getDisplayName = (name) => {
    if (window.innerWidth <= 768) {
        return name.substring(0, 2);
    } else {
        return name;
    }
};

export const setUserCompareStatue = () => {
    return engagementResource.logEngagement({ engType: DID_COMPARE });
};

let getAllEngagementResourcePromise;
const getAllEngagementResource = () => {
    if (!getAllEngagementResourcePromise) {
        getAllEngagementResourcePromise = engagementResource.getAll();
    }
    return getAllEngagementResourcePromise;
};

export const getUserCompareStatue = async () => {
    const userEngagements = await getAllEngagementResource();
    const userCompareStatus = userEngagements.hasOwnProperty(DID_COMPARE);
    return userCompareStatus;
};

export const setStateCompareStatus = (stateId) => {
    return engagementResource.logEngagement({ engType: `${stateId}` });
};

const getStateCompareStatus = async (stateId) => {
    const userEngagements = await engagementResource.getAll();
    const stateCompareStatus = userEngagements.hasOwnProperty(`${STATE_COMPARE_PREFIX}_${stateId}`);
    return stateCompareStatus;
};

export const getAllStatesCompareStatus = async () => {
    const userEngagements = await getAllEngagementResource();
    const states = Object.keys(userEngagements).filter((key) => key.indexOf(STATE_COMPARE_PREFIX) > -1);
    return states;
};
